import { lazy } from 'react';
/** Открывает карточку исполнителя */
export const ExecutorDetailsPageAsync = lazy(() => import('./ExecutorDetails/ExecutorDetailsPage'));